export default __webpack_public_path__ + "static/design_reversed-poster-eb7c3709b65c0c65403baf178598b330.avif";